import {
    Box,
    Button,
    Divider,
    Flex,
    Heading,
    Text,
    VStack
} from "@chakra-ui/react";
import SummaryTickets from "./SummaryTickets";

const SummaryStep = ({data, next, prev, setStep, t}) => {
    const {isCompany, firstName, lastName, buyerCompanyName, buyerNIP, buyerAddress, buyerPostalCode, buyerCity, email, phone, info, attendees, ticketTypes, cart, isFree} = data;

    return (
        <VStack spacing={6} align="stretch" gap="48px">
            <Text fontFamily="body" fontSize="18px" fontWeight="500">
                {t('order.step.summary.title')}
            </Text>
            <Box bg="#F8F5F4" borderRadius="8px" p={{ base: '16px', md: '20px' }}>
                <Heading size="md" mb="16px">
                    <Flex justifyContent={"space-between"}>
                        <Text>{t('order.tab.my_data')}</Text>
                        <Button border={0} bgColor={"transparent"} textDecoration={"underline"} color={"#7A1F35"} p={0} h={"auto"}
                                fontFamily="body" fontSize="18px" fontWeight="500" onClick={() => setStep(0)}>
                            {t('order.form.edit_data')}
                        </Button>
                    </Flex>
                </Heading>
                <Flex gap="20px" flexDirection={"column"} fontFamily="body" fontSize="18px" fontWeight="500" w={"full"}>
                    {isCompany ? (
                        <>
                            <Flex gap="16px" flexDirection={{base: 'column', md: 'row'}}>
                                <Box flex="1" gap="4px">
                                    <Text>{t('order.form.companyName')}</Text>
                                    <Text fontWeight="700">{buyerCompanyName}</Text>
                                </Box>
                                <Box flex="1" gap="4px">
                                    <Text>{t('order.form.nip')}</Text>
                                    <Text fontWeight="700">{buyerNIP}</Text>
                                </Box>
                            </Flex>
                            <Flex gap="16px" flexDirection={{base: 'column', md: 'row'}}>
                                <Box flex="1" gap="4px">
                                    <Text>{t('order.form.address')}</Text>
                                    <Text fontWeight="700">{buyerAddress}</Text>
                                </Box>
                                <Box flex="1" gap="4px">
                                    <Text>{t('order.form.location')}</Text>
                                    <Text fontWeight="700">{buyerPostalCode} {buyerCity}</Text>
                                </Box>
                            </Flex>
                        </>
                    ) : (
                        <Flex gap="16px" flexDirection={{base: 'column', md: 'row'}}>
                            <Box flex="1" gap="4px">
                                <Text>{t('order.form.fullName')}</Text>
                                <Text fontWeight="700">{firstName} {lastName}</Text>
                            </Box>
                            <Box flex="1" gap="4px"/>
                        </Flex>
                    )}
                    <Flex gap="16px" flexDirection={{base: 'column', md: 'row'}}>
                        <Box flex="1" gap="4px">
                            <Text>{t('order.form.email')}</Text>
                            <Text fontWeight="700">{email}</Text>
                        </Box>
                        <Box flex="1" gap="4px">
                            <Text>{t('order.form.phone')}</Text>
                            <Text fontWeight="700">{phone || t('order.form.lack')}</Text>
                        </Box>
                    </Flex>
                    {!isCompany && info && (
                        <Box gap="4px">
                            <Text>{t('order.form.information')}</Text>
                            <Text fontWeight="700">{info}</Text>
                        </Box>
                    )}
                </Flex>
            </Box>

            <Divider borderColor="#ECE4E4" />

            <Box bg="#F8F5F4" borderRadius="8px" p={{ base: '16px', md: '20px' }}>
                <Heading size="md" mb="16px">
                    <Flex justifyContent={"space-between"}>
                        <Text>{t('order.form.your_tickets')}</Text>
                        <Button border={0} bgColor={"transparent"} textDecoration={"underline"} color={"#7A1F35"} p={0} h={"auto"}
                                fontFamily="body" fontSize="18px" fontWeight="500" onClick={() => setStep(1)}>
                            {t('order.form.edit_tickets_detail')}
                        </Button>
                    </Flex>
                </Heading>
                <SummaryTickets attendees={attendees} ticketTypes={ticketTypes} cart={cart} isFree={isFree} t={t} />
            </Box>

            <Flex justify="space-between" gap={{base: '8px', md: '16px'}}>
                <Button
                    w={{base: '35%', md: '20%'}}
                    bgColor={'#FFFFFF'}
                    color={'#7A1F35'}
                    fontFamily="body"
                    fontWeight="400"
                    fontSize={{base: '14px', md: '18px'}}
                    alignSelf="flex-end"
                    py="30px"
                    gap="12px"
                    style={{border: '1.5px solid #7A1F35'}}
                    onClick={prev}>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 20L3 12.5M3 12.5L10.5 5M3 12.5L21 12.5" stroke="#7A1F35" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <Text display={{base: 'none', md: 'block'}}>
                        {t("order.form.come_back")}
                    </Text>
                </Button>
                <Button
                    w={"full"}
                    bgColor={'#7A1F35'}
                    color={'#FFFFFF'}
                    fontFamily="body"
                    fontWeight="400"
                    fontSize={{base: '14px', md: '18px'}}
                    alignSelf="flex-end"
                    py="30px"
                    gap="12px"
                    onClick={next}>
                    {t(isFree ? 'order.form.to_reservation' : 'order.form.to_payment')}
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 5L21.5 12.5M21.5 12.5L14 20M21.5 12.5H3.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </Button>
            </Flex>
        </VStack>
    );
}

export default SummaryStep;
